import { withHydrate } from '@relay/react/hooks';
import { isSSR } from '@helpers/ssr';
import withRedux from '@helpers/withRedux';
import { withMotion } from '@hoc/withMotion';
import { withRouter } from '@hoc/withRouter';
import useWhenWindowLoaded from '@hooks/useWhenWindowLoaded';
import Loader from '@stories/Elements/Misc/Loader/Loader.hybrid';
import RatingStars from '@stories/Elements/Misc/RatingStars/RatingStars';
import LazyProductDetailsSection from '@stories/Widgets/ProductDetail/LazyProductDetailsSection/LazyProductDetailsSection';
import React, { lazy, Suspense, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ProductReviewsListingStyles as s } from './ProductReviewsListing.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LazyProductReviewsListing = /*#__PURE__*/lazy(() => import('./ProductReviewListing.lazy'));
const ProductReviewsListing = props => {
  const windowLoaded = useWhenWindowLoaded();
  const reviewBreakdown = props.reviewBreakdown ? props.reviewBreakdown : useSelector(x => x.productDetail.reviewBreakdown);
  const getTeaser = () => {
    if (!reviewBreakdown || reviewBreakdown.totalReviews === 0) {
      return null;
    }
    let text = props.totalReviewsText;
    text = text.replace('[rating]', `${reviewBreakdown.average}/5`);
    text = text.replace('[count]', `${reviewBreakdown.totalReviews}`);
    return /*#__PURE__*/_jsxs(s.Teaser, {
      children: [/*#__PURE__*/_jsx(RatingStars, {
        averageReviewRating: reviewBreakdown.rawRatingAverage || 0
      }), /*#__PURE__*/_jsx("span", {
        children: text
      })]
    });
  };
  useEffect(() => {
    if (!windowLoaded) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    if (params.get('openreviews') !== '1') {
      return;
    }
    const container = document.querySelector('.js-reviews-anchor');
    if (!container) {
      return;
    }
    container.scrollIntoView({
      block: 'center'
    });
  }, [windowLoaded]);
  return /*#__PURE__*/_jsx(s.OuterContainer, {
    className: "js-reviews-anchor",
    children: /*#__PURE__*/_jsx(LazyProductDetailsSection, {
      title: props.sectionTitle,
      subHeader: getTeaser(),
      navigationTitle: props.navigationTitle,
      openByDefault: props.isLegacyPage && !isSSR,
      useLegacyContainer: props.isLegacyPage && !props.isMxFuel,
      queryParam: 'openreviews',
      children: /*#__PURE__*/_jsx(Suspense, {
        fallback: /*#__PURE__*/_jsx(Loader, {
          delay: 375
        }),
        children: /*#__PURE__*/_jsx(LazyProductReviewsListing, {
          ...props
        })
      })
    })
  });
};
export const clientConfig = {
  hydrate: 'always'
};
export default withHydrate(withRedux(withRouter(withMotion(ProductReviewsListing))), 'ProductReviewsListing', 'hybrid');
